import { Injectable } from '@angular/core';
import { TvaModel } from '../shared/models/simple-types/tva.model';
import { TvaService } from '../shared/services/simple/tva.service';

@Injectable()
export class AmountComponentService {

  tvas: TvaModel[];
  constructor(
    private tvaService: TvaService
  ) {
    this.tvaService.getAll().subscribe(res => {
      this.tvas = res;
    });
  }

  getHt(objectModel: any): number[] {
    if (objectModel.length > 0) {
      const amountHTs = [];
      // let amountHT = 0;
      // tslint:disable-next-line
      for (let index = 0; index < objectModel.length; index++) {
        if (objectModel[index].pu !== undefined && objectModel[index].qte !== undefined) {
          const amountHT = {
            amount: objectModel[index].pu * objectModel[index].qte
          };
          amountHTs.push(amountHT);
        }
      }
      return amountHTs;
    }
    return [0];
  }

  getTva(objectModel: any): string[] {
    if (objectModel.length > 0) {
      const amountTVAs = [];
      // tslint:disable-next-line
      for (let index = 0; index < objectModel.length; index++) {
        // tslint:disable-next-line: max-line-length
        if (objectModel[index].pu !== undefined && objectModel[index].qte !== undefined && objectModel[index].tauxTva !== undefined && this.tvas) {
          const tva = this.tvas.find(t => t.code === objectModel[index].codeTva);
          if (tva) {
            const taux = tva.autoIntra ? 0 : tva.taux;
            const amountTVA = {
              amount: ((objectModel[index].pu * objectModel[index].qte) * taux) / 100
            };
            amountTVAs.push(amountTVA);
          }
        }
      }
      return amountTVAs;
    }
    return ['0'];
  }

  getTtc(objectModel: any): string[] {
    if (objectModel.length > 0) {
      const amountTTCs = [];
      // tslint:disable-next-line
      for (let index = 0; index < objectModel.length; index++) {
        // tslint:disable-next-line: max-line-length
        if (objectModel[index].pu !== undefined && objectModel[index].qte !== undefined && objectModel[index].tauxTva !== undefined && this.tvas) {
          const tva = this.tvas.find(t => t.code === objectModel[index].codeTva);
          if (tva) {
            const taux = tva.autoIntra ? 0 : tva.taux;
            const amountTTC = {
              // tslint:disable-next-line
              amount: (objectModel[index].pu * objectModel[index].qte) + ((objectModel[index].pu * objectModel[index].qte) * taux) / 100
            };
            amountTTCs.push(amountTTC);
          }
        }
      }
      return amountTTCs;
    }
    return ['0'];
  }

}
